export function shouldRevealArchiveBoundary({
    entry,
    shouldSplitKinks,
    showArchive
}) {
    return Boolean(
        entry?.isIntersecting
        && shouldSplitKinks
        && !showArchive
    );
}

export function shouldLoadNextKinkPage({
    entry,
    entityType,
    hasMore,
    loadingMore,
    loading
}) {
    return Boolean(
        entry?.isIntersecting
        && entityType === 'kinks'
        && hasMore
        && !loadingMore
        && !loading
    );
}
